<template>
  <div class="tradeManage">
    <div class="tradeManageBg">
      <div class="tradeHead">
        <!-- <form action="/sps/mp/orderPrint" method="post" >
          <input type="submit"  value="dayin"/>
        </form> -->
        <span class="tradeHead-title">交易数据</span>
        <el-button type="primary" @click="outExcel" class="excelBtn">导出报表</el-button>
      </div>
      <tradesearch v-on:billSearch="searchList($event)" v-on:timeChange="timeChange"></tradesearch>
      <total :data="totalData"></total>
      <tradetable :trade="tradeData"></tradetable>
      <page
        v-on:clickPage="clickPage"
        :currentPage="currentPage"
        :total="tradeCount"
      />
    </div>
  </div>
</template>
<script>
import tradesearch from '@/components/TradeSearch';
import tradetable from '@/components/TradeTable';
import Total from '@/components/Total';
import { tradeOrder } from '@/api/trade';
import page from '../components/PageIndex';
import { downloadExcel } from '@/utils/downloadFetch';
import {mapGetters} from 'vuex';
import {
  shop_url
} from '@/global';
export default {
  components: {
    tradesearch,
    tradetable,
    page,
    Total
  },
  data () {
    return {
      currentPage: 1,
      search: {
        range: [],
        id: 0,
        type: 0,
        mchId: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'chooseCompany',
      'tradeCount',
      'tradeTotal',
      'tradeData',
      'totalData'
    ])
  },
  created () {
    this._getList()
  },
  methods: {
    clickPage (val) {
      this.currentPage = val
      this._getList()
    },
    searchList (form) {
      this.currentPage = 1
      this.search = form
      this._getList()
    },
    timeChange (form) {
      console.log(form)
      this.search = form
    },
    _getList () {
      let data = {
        id: this.search.id,
        type: this.search.type,
        payType: this.search.payType,
        page: this.currentPage,
        start: this.search.range[0],
        mchId: this.$store.getters.mchId,
        end: this.search.range[1],
        userName:this.search.userName,
        amount:this.search.amount
      }
      this.$store.dispatch('getTradeInfo', data)
    },
    outExcel () {
      console.log(this.search)
      // let formDate = new FormData();
      // formDate.append('mchId', this.$store.getters.mchId);
      // formDate.append('type', this.search.type);
      // formDate.append('userId', (this.$store.getters.chooseCompany).userId);
      // formDate.append('start', this.search.range[0]);
      // formDate.append('end', this.search.range[1]);
      let data = {
        type: this.search.type,
        userId: (this.$store.getters.chooseCompany).userId,
        start: this.search.range[0],
        mchId: this.$store.getters.mchId,
        end: this.search.range[1]
      }
      downloadExcel({
        method: 'post',
        url: `${shop_url}/shop/mp/orderPrint`,
        data: data,
        fileName: `${(this.$store.getters.chooseCompany).name}统计报表`
      }).then(res => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../style/mixin.scss";
@import "../style/_variables.scss";

.tradeManage {
  // width: 100%;
  margin: 0 16px;
  // background-color: #fff;
  padding-top: 16px;
  background-color: #e4e9ec;
  // margin-top: 50px;
}

.tradeManageBg {
  background-color: #fff;
}

.tradeHead {
  width: 99%;
  padding-top: 20px;
  @include flex-row;
  justify-content: space-between;
}

.tradeHead-title {
  margin-left: 30px;
  font-size: $font-18;
  color: $color-52;
}

.excelBtn {
  width: 126px;
  background-color: #0891d7;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/pages/TradeManagement.vue